import NotFound from './NotFound';
import Maintanence from './Maintanence';

export { NotFound, Maintanence };



// WEBPACK FOOTER //
// ./src/pages/Errors/index.js